// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__14eNd","title":"ClientInsurance_title__1Iizh","itemText":"ClientInsurance_itemText__2XbTN"};